<script>
import isFunction from 'lodash/isFunction';
import CarTypeModel from '@models/CarType';
import BlockingContainer from '@components/BlockingContainer';
import FileWrapper from '@components/FileWrapper';
import editFormChange from '@mixins/editFormChange';
import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
  components: {
    BlockingContainer,
    FileWrapper,
    Verte
  },
  mixins: [editFormChange],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      carType: {
        name: null,
        avatar: null,
        color: null
      },
      defaultCar: {
        name: null,
        avatar: null,
        color: null
      },
      newAvatar: []
    };
  },
    mounted() {
    if (this.loadedId) {
      this.$wait.start('car type loading');
      CarTypeModel.find(this.loadedId).then((response) => {
        this.carType = Object.assign({}, this.carType, response);
        this.$wait.end('car type loading');
        this.$nextTick(() => {
          this.initChangeWatcher(['carType'], this.validate);
        });
      });
    }
  },
  methods: {
    validate(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('car type loading');
          this.submit(callback);
        }
      });
    },
    submit(callback) {
      if (this.$route.params.id) {
        this.carType.id = this.$route.params.id;
      }
      new CarTypeModel(
        Object.assign({}, this.carType, {
          avatar: Array.isArray(this.newAvatar) && this.newAvatar.length > 0 ? this.newAvatar[0] : this.carType.avatar,
        })
      )
        .save()
        .then((response) => {
          this.carType = response;
          this.$emit('submitted', callback && isFunction(callback));
          if (callback && isFunction(callback)) callback();
          this.$wait.end('car type loading');
        })
        .catch(() => this.$wait.end('car type loading'));
    },
    removeAvatar() {
      this.carType.avatar = null;
    }
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('car type loading')"></BlockingContainer>
    <b-form @submit.prevent="validate">
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.name') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          v-model="carType.name"
          v-validate="'required|max:255'"
          data-vv-value-path="localValue"
          data-vv-name="name"
          :data-vv-as="$t('fields.name')"
          type="text"
          :state="errors.has('name') ? false : null"
          aria-describedby="input-feedback-name"
          :class="errors.has('name', 'carType-form') ? 'is-invalid' : null"
          :placeholder="$t('placeholders.name')"
        >
        </b-form-input>
        <b-form-invalid-feedback id="input-feedback-name">
          <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.avatar') }}:
          <b-button v-if="carType.avatar" size="sm" variant="outline-danger" @click="removeAvatar">
            {{ $t('actions.delete') }}
          </b-button>
        </template>
          <b-avatar
            v-if="carType.avatar"
            size="60px"
            :src="carType.avatar.small"
            alt="Avatar"
            class="mb-2"
          />
        <FileWrapper
          v-model="newAvatar"
          v-validate="{ image: true }"
          :data-vv-as="$t('fields.avatar')"
          :state="errors.has('avatar', 'carType-form') ? false : null"
          :placeholder="$t('placeholders.avatar')"
          accept="image/*"
          aria-describedby="input-feedback-avatar"
          name="avatar"
        >
        </FileWrapper>

        <div v-show="errors.has('avatar', 'carType-form')" class="invalid-feedback d-block mt-1">
          {{ errors.first('avatar', 'carType-form') }}
        </div>
      </b-form-group>
      <b-form-group :label="$t('fields.color')">
         <Verte v-model="carType.color" picker="square" model="hex" style="float:left;"></Verte>
      </b-form-group>
      <b-button type="submit" :disabled="errors.any()" :variant="'outline-' + (!errors.any() ? 'dark' : 'danger')">
        {{ $t('actions.submit') }}
      </b-button>
    </b-form>
  </div>
</template>
